import React from 'react';
import PropTypes from 'prop-types';
import { Button, Card, Checkbox, Grid, Icon, Input, Menu } from 'semantic-ui-react';
import LibraryItemShow from './LibraryItemShow';
import { Dthc } from '../../../Modules';
import styles from '../..//Proposal.scss';
import LineItemEditMobile from '../LineItems/LineItemEditMobile';
import LibraryItemEditDesktop from './LibraryItemEditDesktop';
import LineItemShow from '../LineItems/LineItemShow';
import Formsy from 'formsy-react';

export default class LibraryDesktop extends React.Component {
  static propTypes = {
    serviceChangeHandler: PropTypes.func.isRequired,
    updateService: PropTypes.func.isRequired,
    resetEditService: PropTypes.func.isRequired,
    deleteService: PropTypes.func.isRequired,
    newLibraryLineItemChangeHandler: PropTypes.func.isRequired,
    createService: PropTypes.func.isRequired,
    resetAddService: PropTypes.func.isRequired,
    serviceSelectHandler: PropTypes.func.isRequired,
    library: PropTypes.array.isRequired,
    localLibrary: PropTypes.array.isRequired,
    selectAll: PropTypes.func.isRequired,
    selectNone: PropTypes.func.isRequired,
    addSelected: PropTypes.func.isRequired,
    getTotalSelected: PropTypes.func.isRequired,
    initiallyExpanded: PropTypes.bool,
    newService: PropTypes.object.isRequired,
    toggleServiceSelect: PropTypes.func.isRequired,
    updateSearchQuery: PropTypes.func.isRequired,
    searchQuery: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'library',
      expanded: this.props.initiallyExpanded === undefined ? true : this.props.initiallyExpanded
    };
    this.setActiveTab = this.setActiveTab.bind(this);
    this.toggleExpanded = this.toggleExpanded.bind(this);
    this.addSelected = this.addSelected.bind(this);
    this.addNewLineItem = this.addNewLineItem.bind(this);
    this.addNewLibraryLineItem = this.addNewLibraryLineItem.bind(this);
    this.createService = this.createService.bind(this);
  }

  setActiveTab(activeTab) {
    this.setState({ activeTab });
    if (activeTab === 'library') this.props.resetAddService();
  }

  createService(idx, onSuccess) {
    this.props.createService(idx, () => {
      this.setActiveTab('library');
      if (onSuccess) onSuccess();
    });
  }

  addSelected() {
    this.toggleExpanded(false);
    this.props.addSelected();
  }

  addNewLineItem() {
    this.props.newLibraryLineItemChangeHandler(
      Object.assign({}, this.props.newService, { addToLibrary: false })
    );
    this.setActiveTab('new');
  }

  addNewLibraryLineItem() {
    this.props.newLibraryLineItemChangeHandler(
      Object.assign({}, this.props.newService, { addToLibrary: true })
    );
    this.setActiveTab('new');
  }

  toggleExpanded(expanded) {
    if (typeof expanded === 'boolean') {
      this.setState({ expanded });
    } else {
      this.setState({ expanded: !this.state.expanded });
    }
  }

  render() {
    const maxHeight = this.state.expanded ? '450px' : '280px';
    const { searchQuery } = this.props;
    return (
      <div>
        <Menu tabular attached='top' style={{ marginLeft: '-1px' }}>
          <Menu.Item
            name='Add from Library'
            active={this.state.activeTab === 'library'}
            onClick={this.setActiveTab.bind(null, 'library')}
          />
          <Menu.Item
            name='Add New Item'
            active={this.state.activeTab === 'new'}
            onClick={this.addNewLineItem}
          />
        </Menu>
        <Card fluid className={styles.addService} style={{ marginTop: 0 }}>
          <Card.Content style={{ padding: '0' }}>
            {this.state.activeTab === 'library' &&
              <div>
                <Grid container padded columns='equal' verticalAlign='middle'>
                  <Grid.Row>
                    <Grid.Column>
                      <Formsy.Form style={{ display: 'inline', paddingRight: '1em' }} autoComplete='off'>
                        <Input
                          name='search'
                          type='text'
                          size='small'
                          icon='search'
                          placeholder='Filter...'
                          onChange={this.props.updateSearchQuery}
                          value={searchQuery}
                        />
                      </Formsy.Form>
                    </Grid.Column>
                    <Grid.Column textAlign='right'>
                      {this.props.getTotalSelected() > 0 &&
                        <div>
                          {this.props.getTotalSelected()} Selected
                          <Button
                            onClick={this.addSelected}
                            primary
                            style={{ marginLeft: '1em' }}
                          >
                            Add
                          </Button>
                        </div>}
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <div style={{ maxHeight, overflowY: 'auto' }}>
                  {this.props.library.length === 0 &&
                    <div style={{ textAlign: 'center', padding: '2em' }}>
                      {searchQuery === '' &&
                        <h4>You have no saved line items.</h4>}
                      {searchQuery !== '' &&
                        <h4>No results for "{searchQuery}"</h4>}
                      <br />
                      <Button
                        onClick={this.addNewLibraryLineItem}
                        primary
                        icon='plus'
                        labelPosition='left'
                        content='Add New Item'
                      />
                    </div>}
                  {this.props.library.map((service, idx) =>
                    <div key={service.node.id || idx}>
                      <div
                        style={{ display: 'table-cell', padding: '1em' }}
                        className={[
                          styles.libraryItem,
                          this.props.localLibrary[idx].checked ? styles.itemSelected : ''
                        ].join(' ')}
                        onClick={this.props.toggleServiceSelect.bind(null, idx)}
                      >
                        <Checkbox
                          checked={this.props.localLibrary[idx].checked || false}
                          onChange={this.props.serviceSelectHandler.bind(
                            null,
                            idx
                          )}
                        />
                      </div>
                      <div style={{ display: 'table-cell', width: '100%' }}>
                        <Dthc
                          service={service.node}
                          localService={
                            this.props.localLibrary[idx].node
                          }
                          onChange={svc => {
                            this.props.serviceChangeHandler(svc, idx);
                          }}
                          commitUpdate={this.props.updateService}
                          desktop={LibraryItemEditDesktop}
                          mobile={LibraryItemShow}
                          index={idx}
                          reset={this.props.resetEditService}
                          delete={this.props.deleteService}
                        >
                          <LibraryItemShow
                            service={service.node}
                            index={idx}
                          />
                        </Dthc>
                      </div>
                    </div>
                  )}
                </div>
                <Grid container padded columns='equal' verticalAlign='middle'>
                  <Grid.Row>
                    <Grid.Column>
                      {this.props.library.length > 0 &&
                        <div>
                          <a onClick={this.props.selectAll}>Select All</a>{' '}
                          &nbsp;/&nbsp;&nbsp;
                          <a onClick={this.props.selectNone}>Deselect All</a>
                        </div>
                      }
                    </Grid.Column>
                    <Grid.Column textAlign='center'>
                      <a onClick={this.toggleExpanded}>
                        <Icon name={`chevron ${this.state.expanded ? 'up' : 'down'}`} />
                      </a>
                    </Grid.Column>
                    <Grid.Column textAlign='right'>
                      {this.props.getTotalSelected() > 0 &&
                        <div>
                          {this.props.getTotalSelected()} Selected
                          <Button
                            onClick={this.addSelected}
                            primary
                            style={{ marginLeft: '1em' }}
                          >
                            Add
                          </Button>
                        </div>
                      }
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </div>}
            {this.state.activeTab === 'new' &&
              <Dthc
                service={this.props.newService}
                localService={this.props.newService}
                onChange={service => {
                  this.props.newLibraryLineItemChangeHandler(service);
                }}
                commitUpdate={this.createService}
                desktop={LibraryItemEditDesktop}
                mobile={LineItemEditMobile}
                initiallyOpen
                editorOpen
                isNew
              >
                <LineItemShow service={this.props.newService.node} />
              </Dthc>}
          </Card.Content>
        </Card>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/Library/LibraryDesktop.js